﻿export const budgetRangeSelector = () => {
    const fromSelect = document.querySelector('.range-selector__content .dropdown__container[data-filter="priceFrom"] select');
    const toSelect = document.querySelector('.range-selector__content .dropdown__container[data-filter="priceTo"] select');
    const submitButton = document.getElementById('search-budget-submit');
    let baseUrl = document.querySelector('.range-selector[data-component="range-selector"]');
    let currentUrl = baseUrl.dataset.baseUrl;

    const onFromChange = (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const dataValue = selectedOption.dataset.value;

        Array.from(toSelect.options).forEach(option => {
            const optionPrice = parseInt(option.dataset.value);
            option.disabled = optionPrice <= parseInt(dataValue);
        })
        updateUrl(dataValue || "{priceFrom}", "from");

    }

    const onToChange = (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const dataValue = selectedOption.dataset.value;

        Array.from(fromSelect.options).forEach(option => {
            const optionPrice = parseInt(option.dataset.value);
            option.disabled = optionPrice >= parseInt(dataValue);
        })

        updateUrl(dataValue || "{priceTo}", "to");
    }

    const updateUrl = (value, type) => {

        if (type ==='from') {
            currentUrl = currentUrl.replace(/\/[^/]+(?=\/[^/]+$)/, `/${value}`)
        } else if (type === "to") {
            currentUrl = currentUrl.replace(/\/[^/]+$/, `/${value}`)
        }

        baseUrl.dataset.baseUrl = currentUrl;
    }

    const onSubmit = () => {
        // Check if from or to are left untouched, and convert as needed
        currentUrl = currentUrl.replace(/\/\{priceFrom\}\/\d+/, (match) => {
            return match.replace('{priceFrom}', '0');
        });

        currentUrl = currentUrl.replace(/\/\{priceFrom\}\/\{priceTo\}/, '');

        currentUrl = currentUrl.replace(/\/\d+\/\{priceTo\}/, (match) => {
            return match.replace('{priceTo}', '');
        });

        window.location.href = (currentUrl);
    }

    const init = () => {
        if (fromSelect && toSelect) {
            fromSelect.addEventListener('change', onFromChange);
            toSelect.addEventListener('change', onToChange);
        }
        if (submitButton) {
            submitButton.addEventListener('click', onSubmit);
        }
    };

    return {
        init
    };
}
